const tutorialData = {
    metadata: {
        id: 'tutorial',
    },
    links: {
        aP1EHlKvrNgjPx1kElhZ0: {
            id: 'aP1EHlKvrNgjPx1kElhZ0',
            source: 'AHiu8yMyfhq5ZYnjuoIn0',
            target: '6Z-x843ah7e0b0fZMReph',
        },
        'WXCl7YDCOuoK-X7ZAOfEY': {
            id: 'WXCl7YDCOuoK-X7ZAOfEY',
            source: 'AHiu8yMyfhq5ZYnjuoIn0',
            target: 'SALvRB6xX4hqjJVjU6Y_b',
        },
        F39NcKCnnIjtqGPzvoA1W: {
            id: 'F39NcKCnnIjtqGPzvoA1W',
            source: 'EwfSxmoKarx3n7W1mJy8s',
            target: '8N-6eZFYDRjV2MmtRHqZD',
        },
        IjnvakXbzDwcf84oBqYCb: {
            id: 'IjnvakXbzDwcf84oBqYCb',
            source: 'SALvRB6xX4hqjJVjU6Y_b',
            target: 'aoHmIUmem-T3Zg_VOEvRr',
        },
        'KGeuXb3kocr6rZTAOr-i_': {
            id: 'KGeuXb3kocr6rZTAOr-i_',
            source: '8N-6eZFYDRjV2MmtRHqZD',
            target: 'wzwAxT0LV6sfNjOgv31fx',
        },
        'ps9k-tiBPP0cH9ymY4Myy': {
            id: 'ps9k-tiBPP0cH9ymY4Myy',
            source: 'JCnC9yAUfQ3IXvnj_THs8',
            target: 'agP9N5iMMR8mJF1s5Wthr',
        },
        'jNo6CHcnaxjK7Bk4e-bAc': {
            id: 'jNo6CHcnaxjK7Bk4e-bAc',
            source: 'AHiu8yMyfhq5ZYnjuoIn0',
            target: 'rxyYL1-vZysaZgRMzDXNU',
        },
        bPRss4q2Tvzn_ea1TY4Wr: {
            id: 'bPRss4q2Tvzn_ea1TY4Wr',
            source: 'rxyYL1-vZysaZgRMzDXNU',
            target: 'jPkhyrgf3HOvPALhbfWYj',
        },
        CsKDxvFhIxKDk_m6Bj8Dh: {
            id: 'CsKDxvFhIxKDk_m6Bj8Dh',
            source: '3nj7Xpr-AdGt3rKLomiK5',
            target: 'anvYLObXrGTWIk8T3R2rq',
        },
        DTZkgJWGKYriyalyLJfZx: {
            id: 'DTZkgJWGKYriyalyLJfZx',
            source: 'EIB7xARz2ceZcpBkE940d',
            target: 'anvYLObXrGTWIk8T3R2rq',
        },
        NBLwCo0fXhOXI6DGjqtWU: {
            id: 'NBLwCo0fXhOXI6DGjqtWU',
            source: '3nj7Xpr-AdGt3rKLomiK5',
            target: 'KsZsnbXyRuVqf3FKtK0BA',
        },
    },
    nodes: {
        AHiu8yMyfhq5ZYnjuoIn0: {
            id: 'AHiu8yMyfhq5ZYnjuoIn0',
            type: 'note',
            content: '<h1>Hello! Welcome to Intrigue 👋</h1><p></p><p>Using this app, you can quickly write down your ideas and corresponding references, and make your academic writing faster.</p>',
            links: [
                'aP1EHlKvrNgjPx1kElhZ0',
                'WXCl7YDCOuoK-X7ZAOfEY',
                'jNo6CHcnaxjK7Bk4e-bAc',
            ],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 558,
            y: 99,
            w: 445.00390000000004,
            currentX: 558,
            currentY: 99,
            currentWidth: 445.00390000000004,
            currentHeight: 75,
            h: 79,
        },
        SALvRB6xX4hqjJVjU6Y_b: {
            id: 'SALvRB6xX4hqjJVjU6Y_b',
            type: 'note',
            content: '<h2>This is a note.</h2><p></p><p>Notes comes with <strong>WYSIWYG markdown</strong> support.</p>',
            links: [
                'WXCl7YDCOuoK-X7ZAOfEY',
                'IjnvakXbzDwcf84oBqYCb',
            ],
            parent: null,
            children: [
                'rK2TqMSt-f9f784M19Vro',
            ],
            identifier: null,
            literature: null,
            x: 287,
            y: 191,
            w: 200,
            currentX: 287,
            currentY: 191,
            currentWidth: 200,
            currentHeight: 68,
        },
        'rK2TqMSt-f9f784M19Vro': {
            id: 'rK2TqMSt-f9f784M19Vro',
            type: 'note',
            content: '<p>Notes can be <strong>snapped</strong> together, by dragging one onto another.</p>',
            links: [],
            parent: 'SALvRB6xX4hqjJVjU6Y_b',
            children: [],
            identifier: null,
            literature: null,
            x: 287,
            y: 264,
            w: 200,
            currentX: 287,
            currentY: 264,
            currentWidth: 200,
            currentHeight: 34,
        },
        '6Z-x843ah7e0b0fZMReph': {
            id: '6Z-x843ah7e0b0fZMReph',
            type: 'note',
            content: '<h2>Inspiration</h2><p></p><p>Intrigue is heavily inspired by&nbsp;<strong>Victor Margolin</strong>’s method of organizing research literature and writing, which makes use of note cards and literature canvases.</p>',
            links: [
                'aP1EHlKvrNgjPx1kElhZ0',
            ],
            parent: null,
            children: [
                '8N-6eZFYDRjV2MmtRHqZD',
            ],
            identifier: null,
            literature: null,
            x: 615,
            y: 239,
            w: 329.0079,
            currentX: 615,
            currentY: 239,
            currentWidth: 329.0079,
            currentHeight: 82,
            h: 86,
        },
        '8N-6eZFYDRjV2MmtRHqZD': {
            id: '8N-6eZFYDRjV2MmtRHqZD',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://www.youtube.com/watch?v=Kxyy0THLfuI">https://www.youtube.com/watch?v=Kxyy0THLfuI</a></p>',
            links: [
                'F39NcKCnnIjtqGPzvoA1W',
                'KGeuXb3kocr6rZTAOr-i_',
            ],
            parent: '6Z-x843ah7e0b0fZMReph',
            children: [],
            identifier: 'https://www.youtube.com/watch?v=Kxyy0THLfuI',
            literature: null,
            x: 615,
            y: 326,
            w: 329.0079,
            currentX: 615,
            currentY: 326,
            currentWidth: 329.0079,
            currentHeight: 62,
            referenceType: 'url',
            title: 'The process of writing World History of Design - YouTube',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'The process of writing World History of Design - YouTube',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://www.youtube.com/watch?v=Kxyy0THLfuI',
            },
        },
        EwfSxmoKarx3n7W1mJy8s: {
            id: 'EwfSxmoKarx3n7W1mJy8s',
            type: 'note',
            content: '<p>This is a reference. Try double-clicking it!</p>',
            links: [
                'F39NcKCnnIjtqGPzvoA1W',
            ],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 995,
            y: 268,
            w: 129.00889999999998,
            currentX: 995,
            currentY: 268,
            currentWidth: 129.00889999999998,
            currentHeight: 34,
            h: 38,
        },
        'aoHmIUmem-T3Zg_VOEvRr': {
            id: 'aoHmIUmem-T3Zg_VOEvRr',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax">https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax</a></p>',
            links: [
                'IjnvakXbzDwcf84oBqYCb',
            ],
            parent: null,
            children: [],
            identifier: 'https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax',
            literature: null,
            x: 113,
            y: 362,
            w: 200,
            currentX: 113,
            currentY: 362,
            currentWidth: 200,
            currentHeight: 117,
            referenceType: 'url',
            title: 'Basic writing and formatting syntax - GitHub Docs',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'Basic writing and formatting syntax - GitHub Docs',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://docs.github.com/en/get-started/writing-on-github/getting-started-with-writing-and-formatting-on-github/basic-writing-and-formatting-syntax',
            },
        },
        wzwAxT0LV6sfNjOgv31fx: {
            id: 'wzwAxT0LV6sfNjOgv31fx',
            type: 'note',
            content: '<h2>References</h2><p></p><p>Many things can be <strong>automatically</strong> turned into reference notes, just by <strong>pasting in the identifiers</strong>:</p><p></p><ul><li><p>ISBN</p></li><li><p>DOI</p></li><li><p>Web Link</p></li><li><p>Zotero item link</p></li></ul>',
            links: [
                'KGeuXb3kocr6rZTAOr-i_',
            ],
            parent: null,
            children: [
                'JCnC9yAUfQ3IXvnj_THs8',
            ],
            identifier: null,
            literature: null,
            x: 331,
            y: 591,
            w: 327.0079,
            currentX: 331,
            currentY: 591,
            currentWidth: 327.0079,
            currentHeight: 137,
            h: 141,
        },
        JCnC9yAUfQ3IXvnj_THs8: {
            id: 'JCnC9yAUfQ3IXvnj_THs8',
            type: 'reference',
            content: '<p>10.1561/1100000005</p>',
            links: [
                'ps9k-tiBPP0cH9ymY4Myy',
            ],
            parent: 'wzwAxT0LV6sfNjOgv31fx',
            children: [],
            identifier: '10.1561/1100000005',
            literature: null,
            x: 331,
            y: 733,
            w: 327.0079,
            currentX: 331,
            currentY: 733,
            currentWidth: 327.0079,
            currentHeight: 48,
            referenceType: 'doi',
            title: 'Human-Robot Interaction: A Survey',
            author: [
                {
                    given: 'Michael A.',
                    family: 'Goodrich',
                    sequence: 'first',
                    affiliation: [],
                },
                {
                    given: 'Alan C.',
                    family: 'Schultz',
                    sequence: 'first',
                    affiliation: [],
                },
            ],
            record: {
                indexed: {
                    'date-parts': [
                        [
                            2022,
                            8,
                            5,
                        ],
                    ],
                    'date-time': '2022-08-05T22:49:48Z',
                    timestamp: 1659739788859,
                },
                'reference-count': 0,
                publisher: 'Now Publishers',
                issue: '3',
                'content-domain': {
                    domain: [],
                    'crossmark-restriction': false,
                },
                'published-print': {
                    'date-parts': [
                        [
                            2007,
                        ],
                    ],
                },
                DOI: '10.1561/1100000005',
                type: 'article-journal',
                created: {
                    'date-parts': [
                        [
                            2008,
                            2,
                            5,
                        ],
                    ],
                    'date-time': '2008-02-05T19:23:58Z',
                    timestamp: 1202239438000,
                },
                page: '203-275',
                source: 'Crossref',
                'is-referenced-by-count': 880,
                title: 'Human-Robot Interaction: A Survey',
                prefix: '10.1561',
                volume: '1',
                author: [
                    {
                        given: 'Michael A.',
                        family: 'Goodrich',
                        sequence: 'first',
                        affiliation: [],
                    },
                    {
                        given: 'Alan C.',
                        family: 'Schultz',
                        sequence: 'first',
                        affiliation: [],
                    },
                ],
                member: '432',
                'container-title': 'Foundations and Trends® in Human-Computer Interaction',
                'original-title': [],
                language: 'en',
                deposited: {
                    'date-parts': [
                        [
                            2020,
                            2,
                            27,
                        ],
                    ],
                    'date-time': '2020-02-27T13:58:46Z',
                    timestamp: 1582811926000,
                },
                score: 1,
                resource: {
                    primary: {
                        URL: 'http://www.nowpublishers.com/article/Details/HCI-005',
                    },
                },
                subtitle: [],
                'short-title': [],
                issued: {
                    'date-parts': [
                        [
                            2007,
                        ],
                    ],
                },
                'references-count': 0,
                'journal-issue': {
                    issue: '3',
                    'published-online': {
                        'date-parts': [
                            [
                                2007,
                            ],
                        ],
                    },
                    'published-print': {
                        'date-parts': [
                            [
                                2007,
                            ],
                        ],
                    },
                },
                URL: 'http://dx.doi.org/10.1561/1100000005',
                relation: {},
                ISSN: [
                    '1551-3955',
                    '1551-3963',
                ],
                subject: [
                    'Computer Science Applications',
                    'Human-Computer Interaction',
                ],
                'container-title-short': 'FNT in Human-Computer Interaction',
                published: {
                    'date-parts': [
                        [
                            2007,
                        ],
                    ],
                },
                id: 'temp_id_8637346830865666',
            },
        },
        agP9N5iMMR8mJF1s5Wthr: {
            id: 'agP9N5iMMR8mJF1s5Wthr',
            type: 'note',
            content: '<p>Try double-clicking me as well ;)</p>',
            links: [
                'ps9k-tiBPP0cH9ymY4Myy',
            ],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 543,
            y: 826,
            w: 200,
            currentX: 543,
            currentY: 826,
            currentWidth: 200,
            currentHeight: 20,
        },
        jPkhyrgf3HOvPALhbfWYj: {
            id: 'jPkhyrgf3HOvPALhbfWYj',
            type: 'note',
            content: "<h2>Intrigue uses offline-first distributed collaborative editing.</h2><p></p><p>What does it mean? Let's break it down.</p>",
            links: [
                'bPRss4q2Tvzn_ea1TY4Wr',
            ],
            parent: null,
            children: [
                'n7FUs3oUm4M1FZC-uHzsy',
            ],
            identifier: null,
            literature: null,
            x: 1158,
            y: 222,
            w: 366.0079,
            currentX: 1158,
            currentY: 222,
            currentWidth: 366.0079,
            currentHeight: 75,
            h: 79,
        },
        'rxyYL1-vZysaZgRMzDXNU': {
            id: 'rxyYL1-vZysaZgRMzDXNU',
            type: 'note',
            content: '<h2>↗️ See the button on the top-right corner?</h2><p></p><p>You can click it to get a web link, which you can share with others to collaborate.</p>',
            links: [
                'jNo6CHcnaxjK7Bk4e-bAc',
                'bPRss4q2Tvzn_ea1TY4Wr',
            ],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 1158,
            y: 101,
            w: 366.0079,
            currentX: 1158,
            currentY: 101,
            currentWidth: 366.0079,
            currentHeight: 68,
            h: 72,
        },
        'n7FUs3oUm4M1FZC-uHzsy': {
            id: 'n7FUs3oUm4M1FZC-uHzsy',
            type: 'note',
            content: '<p><strong>Collaborative editing: </strong>You can edit this document together with other people over the internet.</p>',
            links: [],
            parent: 'jPkhyrgf3HOvPALhbfWYj',
            children: [
                '3nj7Xpr-AdGt3rKLomiK5',
            ],
            identifier: null,
            literature: null,
            x: 1158,
            y: 302,
            w: 366.0079,
            currentX: 1158,
            currentY: 302,
            currentWidth: 366.0079,
            currentHeight: 34,
        },
        '3nj7Xpr-AdGt3rKLomiK5': {
            id: '3nj7Xpr-AdGt3rKLomiK5',
            type: 'note',
            content: "<p><strong>Distributed:</strong> There's no central server that stores your data. Each collaborator holds their own copy, and they directly communicate with each other to keep in sync.</p>",
            links: [
                'CsKDxvFhIxKDk_m6Bj8Dh',
                'NBLwCo0fXhOXI6DGjqtWU',
            ],
            parent: 'n7FUs3oUm4M1FZC-uHzsy',
            children: [
                'EIB7xARz2ceZcpBkE940d',
            ],
            identifier: null,
            literature: null,
            x: 1158,
            y: 341,
            w: 366.0079,
            currentX: 1158,
            currentY: 341,
            currentWidth: 366.0079,
            currentHeight: 48,
        },
        EIB7xARz2ceZcpBkE940d: {
            id: 'EIB7xARz2ceZcpBkE940d',
            type: 'note',
            content: "<p><strong>Offline-first:</strong> Because each person has their own copy, you don't need to be online to edit this file. The updates you made will be sent to your collaborators the next time you are all online.</p>",
            links: [
                'DTZkgJWGKYriyalyLJfZx',
            ],
            parent: '3nj7Xpr-AdGt3rKLomiK5',
            children: [],
            identifier: null,
            literature: null,
            x: 1158,
            y: 394,
            w: 366.0079,
            currentX: 1158,
            currentY: 394,
            currentWidth: 366.0079,
            currentHeight: 48,
        },
        anvYLObXrGTWIk8T3R2rq: {
            id: 'anvYLObXrGTWIk8T3R2rq',
            type: 'note',
            content: '<h3>Intrigue uses SyncedStore and Yjs to keep you in sync.</h3><p></p><p>Under the hood, they use algorithms called CRDTs to ensure that all edits are merged correctly, even if made offline.</p>',
            links: [
                'CsKDxvFhIxKDk_m6Bj8Dh',
                'DTZkgJWGKYriyalyLJfZx',
            ],
            parent: null,
            children: [
                '8gRuWiQvD7HjW1v8PirRZ',
            ],
            identifier: null,
            literature: null,
            x: 921,
            y: 546,
            w: 383.00790000000006,
            currentX: 921,
            currentY: 546,
            currentWidth: 383.00790000000006,
            currentHeight: 64,
            h: 68,
        },
        '8gRuWiQvD7HjW1v8PirRZ': {
            id: '8gRuWiQvD7HjW1v8PirRZ',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://yjs.dev">https://yjs.dev</a></p>',
            links: [],
            parent: 'anvYLObXrGTWIk8T3R2rq',
            children: [
                'eGL9rPJ6hhTOecmHN1IPE',
            ],
            identifier: 'https://yjs.dev/',
            literature: null,
            x: 921,
            y: 615,
            w: 383.00790000000006,
            currentX: 921,
            currentY: 615,
            currentWidth: 383.00790000000006,
            currentHeight: 48,
            referenceType: 'url',
            title: 'Yjs Shared Editing',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'Yjs Shared Editing',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://yjs.dev/',
            },
        },
        eGL9rPJ6hhTOecmHN1IPE: {
            id: 'eGL9rPJ6hhTOecmHN1IPE',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://github.com/yousefed/SyncedStore">https://github.com/yousefed/SyncedStore</a></p>',
            links: [],
            parent: '8gRuWiQvD7HjW1v8PirRZ',
            children: [
                'cjmp78kq4aeWsiDHNm3be',
            ],
            identifier: 'https://github.com/yousefed/SyncedStore',
            literature: null,
            x: 921,
            y: 668,
            w: 383.00790000000006,
            currentX: 921,
            currentY: 668,
            currentWidth: 383.00790000000006,
            currentHeight: 75,
            referenceType: 'url',
            title: 'GitHub - YousefED/SyncedStore: SyncedStore CRDT is an easy-to-use library for building live, collaborative applications that sync automatically.',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'GitHub - YousefED/SyncedStore: SyncedStore CRDT is an easy-to-use library for building live, collaborative applications that sync automatically.',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://github.com/yousefed/SyncedStore',
            },
        },
        cjmp78kq4aeWsiDHNm3be: {
            id: 'cjmp78kq4aeWsiDHNm3be',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://crdt.tech">https://crdt.tech</a></p>',
            links: [],
            parent: 'eGL9rPJ6hhTOecmHN1IPE',
            children: [
                '0gI1kCXM_izYBG9FjX-7T',
            ],
            identifier: 'https://crdt.tech/',
            literature: null,
            x: 921,
            y: 748,
            w: 383.00790000000006,
            currentX: 921,
            currentY: 748,
            currentWidth: 383.00790000000006,
            currentHeight: 48,
            referenceType: 'url',
            title: 'About CRDTs • Conflict-free Replicated Data Types',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'About CRDTs • Conflict-free Replicated Data Types',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://crdt.tech/',
            },
        },
        '0gI1kCXM_izYBG9FjX-7T': {
            id: '0gI1kCXM_izYBG9FjX-7T',
            type: 'reference',
            content: '<p><a target="_blank" rel="noopener noreferrer nofollow" href="https://www.inkandswitch.com/local-first/">https://www.inkandswitch.com/local-first/</a></p>',
            links: [],
            parent: 'cjmp78kq4aeWsiDHNm3be',
            children: [],
            identifier: 'https://www.inkandswitch.com/local-first/',
            literature: null,
            x: 921,
            y: 801,
            w: 383.00790000000006,
            currentX: 921,
            currentY: 801,
            currentWidth: 383.00790000000006,
            currentHeight: 48,
            referenceType: 'url',
            title: 'Local-first software: You own your data, in spite of the cloud',
            author: [
                {
                    family: 'Web link',
                },
            ],
            record: {
                title: 'Local-first software: You own your data, in spite of the cloud',
                author: [
                    {
                        family: 'Web link',
                    },
                ],
                identifier: 'https://www.inkandswitch.com/local-first/',
            },
        },
        KsZsnbXyRuVqf3FKtK0BA: {
            id: 'KsZsnbXyRuVqf3FKtK0BA',
            type: 'note',
            content: '<p>This does mean that <strong>someone has to have the file open</strong> when a new person logs on, in order for the new person to get the file content.</p>',
            links: [
                'NBLwCo0fXhOXI6DGjqtWU',
            ],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 794,
            y: 419,
            w: 208.0079,
            currentX: 794,
            currentY: 419,
            currentWidth: 208.0079,
            currentHeight: 62,
            h: 66,
        },
        '7OSkqze_9QwSvHGy_F85x': {
            id: '7OSkqze_9QwSvHGy_F85x',
            type: 'note',
            content: '<p>Snap me to the note above!</p>',
            links: [],
            parent: null,
            children: [],
            identifier: null,
            literature: null,
            x: 287,
            y: 308,
            w: 200,
            currentX: 287,
            currentY: 308,
            currentWidth: 200,
            currentHeight: 20,
        },
    },
    fragment: '',
};

export default tutorialData;
